import _ from 'underscore'
import Collection from './collection'
import activityFactory from '../activity_factory'

/*
 * A heterogenious collection of activities (polls and surveys)
 */
export default class ActivityCollection extends Collection {
  get url () { return '/api/activities' }

  preinitialize () {
    //  Default comparator is by position
    this.comparator = 'position'
  }

  /*
   * @param [Model|Array] models Backbone takes one model or an array of models
   * @param [Object] options
   * @option options [Number] group_id Associate this collection to a group-this passes the `group_id` as a param when fetching
   * @option options [Number] user_id Associate this collection to a user-this passes the `user_id` as a param when fetching
   *
   */
  initialize (models = [], options = {}) {
    this.group_id = options.group_id
    this.user_id = options.user_id
  }

  /*
   * @param [Object] options Basic Bacbone option for a collection.fetch
   * @note By default, the `options.group_id`, and `options.user_id` will be the group that initialized this collection.
   */
  fetch (options = {}) {
    _.defaults(options, {
      data: {}
    })

    _.defaults(options.data, {
      group_id: this.group_id,
      user_id: this.user_id
    })

    return super.fetch(options)
  }

  /*
   * Build an activity from the attributes
   *
   * @param [Object] attrs Model attributes
   * @param [Object] options Model options
   *
   * @return [Model]
   *
   */
  model (attrs, options) {
    return activityFactory(attrs, options)
  }

  /*
   * Compute the id `:type_:id` for the heterogenious models
   *
   * @param [Object] attrs Attributes
   *
   * @return [String] `:type_:id` or null if uncomputable
   *
   */
  modelId (attrs = {}) {
    const { id, type } = attrs

    if (id && type) {
      return `${type}_${id}`
    } else {
      return null
    }
  }

  /*
   * Get a model by its computed id or model id and type
   *
   * @overload get(id)
   *   Get a model by its computed id from `#modelId()` method
   *   @param [String] id Computed id
   *   @return [Model]
   *
   * @overload get(id, type)
   *   Get a model by its id and type
   *   @param [Integer] id Model ID
   *   @param [String] type Model type
   *   @return [Model]
   *
   */
  get (id, type) {
    if (type != null) {
      return this.findWhere({ type, id })
    } else {
      return super.get(...arguments)
    }
  }
}
